import styled from "styled-components";
import { Form, InputGroup } from "react-bootstrap";

export const InputContainer = styled(InputGroup)`
  box-shadow: ${({ $withBoxShadow }) => $withBoxShadow && `var(--box-shadow4)`};
  border: ${({ $withBorder }) =>
    $withBorder
      ? "1px solid var(--blue-color-dark)"
      : "1px solid var(--blue-color-light)"};
  padding: 0 1px;
  color: var(--blue-color-dark);
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: var(--border-radius-1);
  overflow: hidden;
  input {
    border-radius: var(--border-radius-1);
    &:disabled{
      border-radius: inherit;
    }
  }
  input,
  input:focus,
  input:active {
    border: none;
    box-shadow: none;
  }
`;

export const ErrorContainer = styled(Form.Text)`
  color: red;
`;
